import styled from 'styled-components'

export const Root = styled.svg`
  flex-shrink: 0;
  /* SVG inline usa vertical-align: baseline por padrão — desalinha com o
     texto ao lado mesmo dentro de um flex row */
  vertical-align: middle;
  overflow: visible;

  .track {
    stroke: var(--sl-color-gray-2); /* #EBEBEB */
  }
`
